var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2084_192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.14584 0.395752H2.72918L3.79001 5.69596C3.82621 5.8782 3.92535 6.0419 4.07008 6.15841C4.21481 6.27492 4.39591 6.33681 4.58168 6.33325H8.42918C8.61494 6.33681 8.79604 6.27492 8.94077 6.15841C9.08551 6.0419 9.18465 5.8782 9.22084 5.69596L9.85418 2.37492H3.12501M4.70834 8.31242C4.70834 8.53103 4.53112 8.70825 4.31251 8.70825C4.0939 8.70825 3.91668 8.53103 3.91668 8.31242C3.91668 8.09381 4.0939 7.91659 4.31251 7.91659C4.53112 7.91659 4.70834 8.09381 4.70834 8.31242ZM9.06251 8.31242C9.06251 8.53103 8.88529 8.70825 8.66668 8.70825C8.44806 8.70825 8.27084 8.53103 8.27084 8.31242C8.27084 8.09381 8.44806 7.91659 8.66668 7.91659C8.88529 7.91659 9.06251 8.09381 9.06251 8.31242Z",
    stroke: "white",
    strokeWidth: 0.791667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2084_192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.5,
    height: 9.5,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cartIcon.f3c27330d97343789ee0b24314d1b68f.svg";
export { ForwardRef as ReactComponent };